<template>
  <div class="text-warning h-4 text-xs">
    *当前是模拟考专属链接，请用报名手机号登录
  </div>
</template>
